import * as React from 'react';
import '../playerstatselection.css'
import { Modal, Button, ButtonToolbar } from 'react-bootstrap'
import {ChampionRunes} from "../../fbobjects/calculation/CalculationObjects";
import _ = require("lodash");
import RunePage from "../RunePage/index";
import './statmodalcomponent.css';

interface StatModalComponentProps{
    data:ChampionRunes[]
}

export interface StatBlockProps {
    onClick:()=>any;
}

export interface StatBlock extends React.Component<StatBlockProps,any> {

}

export default class StatModalComponent extends React.Component<StatModalComponentProps,any> {

    render(){
        return(
            <div>
                <Modal dialogClassName="dialog-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>PICK A RUNE PAGE</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button >Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/StatModalComponent/index.tsx